<!--
 * @Author: Tommy Chen weiyao_85@163.com
 * @Date: 2024-07-03 10:07:54
 * @LastEditors: Tommy Chen weiyao_85@163.com
 * @LastEditTime: 2024-07-22 16:05:01
 * @FilePath: /macchelp/src/components/FootLogo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="warper clearfix footLogoBox">
      版权所有©2014-{{ currentYear }}
      北京星网锐捷网络技术有限公司
      京ICP备13025710号-1 京公网安备11010802020367号
  </div>
</template>
<script>
export default {
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
}
</script>

<style>
.footLogoBox {
  padding: 1rem;
  text-align: center;
}
.footLogoBox p {
  line-height: 1rem;
}
.footLogoBox a {
  color: #366ea5;
}
.footLogoBox a:hover {
  color: #2b6afd;
}
</style>
